import { getTransferHomeCurrencyEstimate } from '@src/containers/Transfers/transferHomeCurrencyEstimate';
import { useHomeCurrency } from '@src/hooks/useHomeCurrency';
import { getTransferHomeCurrencyEstimateTooltip } from '@src/tokens/tooltips';
import { Box, FormGroup, InlineFormattedNumber, useHomeCurrencyRateValue } from '@talos/kyoko';
import { useTheme } from 'styled-components';

interface TransferFormHomeCurrencyEstimateProps {
  amount: string;
  asset: string;
}

export function TransferFormHomeCurrencyEstimate({ amount, asset }: TransferFormHomeCurrencyEstimateProps) {
  const theme = useTheme();
  const homeCurrencyInfo = useHomeCurrency();
  const homeCurrencyConversionRate = useHomeCurrencyRateValue(asset);
  const estimatedHomeCurrencyTotal = getTransferHomeCurrencyEstimate({
    amount,
    rate: homeCurrencyConversionRate?.Rate,
  });

  if (!homeCurrencyInfo || asset === homeCurrencyInfo.Symbol || estimatedHomeCurrencyTotal == null) {
    return null;
  }

  return (
    <FormGroup
      data-testid="transfer-home-currency-estimate-group"
      inline
      label={`${homeCurrencyInfo.Symbol} Value`}
      labelWidth="7rem"
      controlId="transfer-home-currency-total"
      tooltip={getTransferHomeCurrencyEstimateTooltip(homeCurrencyInfo.Symbol)}
      mb={0}
    >
      <Box textAlign="right" w="100%" pr={theme.spacing8}>
        <InlineFormattedNumber
          align="right"
          currency={homeCurrencyInfo.Symbol}
          estimate
          number={estimatedHomeCurrencyTotal}
          increment={homeCurrencyInfo.DefaultIncrement}
        />
      </Box>
    </FormGroup>
  );
}
